import { UploadedVideoTypes } from "@/interfaces/listing/SellerListing";
import { makeApiImage } from "@/libs/clientConfig";
import Image from "next/image";
import { useEffect, useRef, useState } from "react";
import videojs from "video.js";

import "video.js/dist/video-js.css";

export interface CustomVideoConfig {
  type: UploadedVideoTypes.Custom;
  url: string;
  meta?: {
    mimetype: string;
  };
  // https://videojs.com/guides/options
  options?: any;
}

interface CustomVideoProps {
  video: CustomVideoConfig;
  className?: string;
  icon?: string;
  iconWidth?: number;
  iconHeight?: number;
  disabled?: boolean;
}

const CustomVideo: React.FC<CustomVideoProps> = ({
  video,
  className = "",
  icon = "/assets/video-play-large.svg",
  iconWidth = 49,
  iconHeight = 48,
  disabled = false,
}) => {
  const videoPlayerRef = useRef<HTMLVideoElement | null>(null);
  const [player, setPlayer] = useState<any>(null);
  const [showPlayBtn, setShowPlayBtn] = useState(true);
  const [canPlay, setCanPlay] = useState(false);

  useEffect(() => {
    if (video) {
      initPlayer(video);
    }
  }, [video]);

  const initPlayer = (video: CustomVideoConfig) => {
    if (!videoPlayerRef.current) return;

    const { url, meta, options } = video;
    const src = makeApiImage(url);

    const videoOptions = {
      sources: [{ src, type: meta?.mimetype }],
      controls: true,
      autoplay: false,
      preload: "auto",
      ...options,
    };

    const playerInstance = videojs(videoPlayerRef.current, videoOptions, () => {
      setCanPlay(true);
    });

    setPlayer(null);
    setTimeout(() => {
      setPlayer(playerInstance);
    }, 500);
    // setPlayer(playerInstance);
  };

  const onPlayClick = () => {
    if (!canPlay || disabled) {
      return;
    }

    player?.play();
    setShowPlayBtn(false);
  };

  return (
    <>
      <div className={`relative w-full h-full`}>
        <video
          ref={videoPlayerRef}
          className={`video-js ${className}`}
          controls
          muted
          playsInline
        ></video>

        {showPlayBtn && (
          <div
            className={`absolute inset-0 ${
              canPlay || disabled
                ? "flex justify-center items-center"
                : "hidden"
            } cursor-pointer ${disabled ? "opacity-50" : ""}`}
            onClick={onPlayClick}
          >
            <Image
              src={icon}
              alt="Play Icon"
              width={iconWidth}
              height={iconHeight}
            />
          </div>
        )}

        <style jsx global>{`
          .video-js {
            width: 100%;
            height: 100%;

            .vjs-big-play-button {
              display: none !important;
            }
          }
        `}</style>
      </div>
    </>
  );
};

export default CustomVideo;
